var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_600_1290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.4467 4.95273H22.103C22.2915 4.95273 22.4442 4.80006 22.4442 4.6115C22.4442 4.42297 22.2915 4.27026 22.103 4.27026H8.4467C8.25818 4.27026 8.10547 4.42297 8.10547 4.6115C8.10547 4.80006 8.25818 4.95273 8.4467 4.95273Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.103 11.2848H8.4467C8.25818 11.2848 8.10547 11.4375 8.10547 11.626C8.10547 11.8146 8.25818 11.9673 8.4467 11.9673H22.103C22.2915 11.9673 22.4442 11.8146 22.4442 11.626C22.4442 11.4375 22.2915 11.2848 22.103 11.2848Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.103 18.0972H8.4467C8.25818 18.0972 8.10547 18.2499 8.10547 18.4385C8.10547 18.627 8.25818 18.7797 8.4467 18.7797H22.103C22.2915 18.7797 22.4442 18.627 22.4442 18.4385C22.4442 18.2499 22.2915 18.0972 22.103 18.0972Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.64288 2.5741C1.51948 2.5741 0.605469 3.48811 0.605469 4.61151C0.605469 5.73494 1.51948 6.64895 2.64288 6.64895C3.76631 6.64895 4.68032 5.73494 4.68032 4.61151C4.68032 3.48811 3.76631 2.5741 2.64288 2.5741ZM2.64288 5.98816C1.88373 5.98816 1.26626 5.37069 1.26626 4.61151C1.26626 3.85236 1.88373 3.23489 2.64288 3.23489C3.40206 3.23489 4.01953 3.85236 4.01953 4.61151C4.01953 5.37069 3.40206 5.98816 2.64288 5.98816Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.64288 9.58862C1.51948 9.58862 0.605469 10.5026 0.605469 11.626C0.605469 12.7495 1.51948 13.6635 2.64288 13.6635C3.76631 13.6635 4.68032 12.7495 4.68032 11.626C4.68032 10.5026 3.76631 9.58862 2.64288 9.58862ZM2.64288 13.0027C1.88373 13.0027 1.26626 12.3852 1.26626 11.626C1.26626 10.8669 1.88373 10.2494 2.64288 10.2494C3.40206 10.2494 4.01953 10.8669 4.01953 11.626C4.01953 12.3852 3.40206 13.0027 2.64288 13.0027Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.64288 16.4011C1.51948 16.4011 0.605469 17.3151 0.605469 18.4385C0.605469 19.5619 1.51948 20.4759 2.64288 20.4759C3.76631 20.4759 4.68032 19.5619 4.68032 18.4385C4.68032 17.3151 3.76631 16.4011 2.64288 16.4011ZM2.64288 19.8151C1.88373 19.8151 1.26626 19.1977 1.26626 18.4385C1.26626 17.6793 1.88373 17.0619 2.64288 17.0619C3.40206 17.0619 4.01953 17.6793 4.01953 18.4385C4.01953 19.1977 3.40206 19.8151 2.64288 19.8151Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_600_1290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.85,
    height: 21.85,
    fill: "currentColor",
    transform: "translate(0.599609 0.599976)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.22b64126.svg";
export { ForwardRef as ReactComponent };